/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 **************************************************************************/
export var PostType;
(function (PostType) {
    PostType["Text"] = "text";
    PostType["AssetLink"] = "assetLink";
})(PostType || (PostType = {}));
export var BoardMemberRole;
(function (BoardMemberRole) {
    BoardMemberRole["OWNER"] = "OWNER";
    BoardMemberRole["POSTER"] = "POSTER";
    BoardMemberRole["VIEWER"] = "VIEWER";
    BoardMemberRole["UNKNOWN"] = "UNKNOWN";
})(BoardMemberRole || (BoardMemberRole = {}));
export var BoardType;
(function (BoardType) {
    BoardType["CLASSROOM"] = "classroom";
})(BoardType || (BoardType = {}));
